import { Component, effect, ElementRef, inject, Renderer2 } from '@angular/core';

import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';

import { LayoutService } from './layout.service';

@Component({
  selector: 'app-layout',
  imports: [FooterComponent, HeaderComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  private readonly renderer = inject(Renderer2);
  private readonly elRef = inject(ElementRef);
  private readonly layout = inject(LayoutService);

  constructor() {
    effect(() => {
      const links = this.elRef.nativeElement.querySelectorAll('a[data-link="headerLink"]');
      const linksEnabled = this.layout.linksEnabled();

      if (!linksEnabled) {
        links.forEach((link: HTMLAnchorElement) => {
          this.renderer.setAttribute(link, 'disabled', 'true');
        });
      } else {
        links.forEach((link: HTMLAnchorElement) => {
          this.renderer.removeAttribute(link, 'disabled');
        });
      }
    });
  }
}
